import { ifAuthenticated } from '../utils/authorization.js';
import Chat from '../views/Chat/Chat.vue';

export default [
    {
        path: '/chat/:id?',
        name: 'chat',
        component: Chat, // Do not use code splitting here.
        beforeEnter: ifAuthenticated,
        meta: {
            title: 'chat.pageTitle',
        },
    },
];
